var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9141 18.5156L22.9922 17.4375L18.0547 12.5L22.9922 7.5625L21.9141 6.48438L16.4375 11.9609L15.9219 12.5L16.4375 13.0391L21.9141 18.5156Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3359 3.52344L10.4062 3.5H12V21.5H10.4297L10.3594 21.4766L4.35938 20.3516L3.75 20.2578V5.07031L4.33594 4.92969L10.3359 3.52344ZM13.5 6.5V5H17.25V9.02712L15.75 10.5271V6.5H13.5ZM15.75 14.4729V18.5H13.5V20H17.25V15.9729L15.75 14.4729ZM17.25 11.1484V13.8515L16.4375 13.039L15.9219 12.5L16.4375 11.9609L17.25 11.1484ZM10.5 20V5.02344L5.25 6.24219V19.0156L10.5 20ZM8.74219 12.5C8.74219 12.0869 8.98242 11.75 9.25781 11.75C9.5332 11.75 9.75 12.0869 9.75 12.5C9.75 12.9131 9.5332 13.25 9.25781 13.25C8.98242 13.25 8.74219 12.9131 8.74219 12.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/sign_in.18c3a1f4d55a1dd88afb33eaff1b2d0f.svg";
export { ForwardRef as ReactComponent };